import { Core } from "@faire/design-tokens";
import { CaselineProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/CaseSizeText/CaselineProps";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";

export const Caseline: React.FC<CaselineProps> = ({
  isLoggedIn,
  caseSizeText,
  availabilityText,
}) => {
  const eligibleForInventoryText =
    isLoggedIn && (caseSizeText || availabilityText);

  if (eligibleForInventoryText) {
    return (
      <Row align="baseline" style={{ width: "100%", flexWrap: "wrap" }}>
        {caseSizeText ? (
          <>
            <Typography
              variant="paragraphSansRegular"
              color={Core.text.subdued}
            >
              {caseSizeText}
            </Typography>
            <Spacer width="1x" />
          </>
        ) : null}
        {availabilityText ? (
          <Typography color={Core.text.critical}>{availabilityText}</Typography>
        ) : null}
      </Row>
    );
  }

  return null;
};
